var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 96,
    viewBox: "0 0 136 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7626_13058)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 24,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 44,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 64,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 84,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 4,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 44,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 64,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 84,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 4,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 24,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 44,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 64,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 84,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 4,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 24,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 44,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 64,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 84,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 4,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 24,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 44,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 64,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 84,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 4,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 24,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 44,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 64,
    r: 4,
    fill: "#C9ADA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 84,
    r: 4,
    fill: "#C9ADA7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7626_13058",
    x: 0,
    y: 0,
    width: 136,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7626_13058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7626_13058",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.9390c438a8fe73c30cf394fd0b770778.svg";
export { ForwardRef as ReactComponent };